export default __webpack_public_path__ + "static/way-forward-single-1fb1a1a08a7214e821c518c4644df013.jpg";